module.exports = require("serialize-error");